export default __webpack_public_path__ + "static/media/740.baeb6c97.png";